import React from 'react';
import PropTypes from 'prop-types';

import './no-live-event.scss';

const NoLiveEvent = ({ data }) => {
  return (
    <div className='live_page_container noLiveEvent'>
      <h1 className='live_page_title'>
        No Live Event scheduled at the moment. <br /> Stay tuned for updates.
      </h1>
    </div>
  );
};

NoLiveEvent.propTypes = {
  data: PropTypes.object.isRequired,
};

export default NoLiveEvent;
